import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import Paper from '@mui/material/Paper';

import theme from '../../../theme';
import { styled } from '@mui/material/styles';

// ------------------------ index ------------------------ 
export const GptOutBox = styled(Box)(props => {
  return {
    position: 'relative',
    transition: 'all .3s',
    // overflow: 'hidden'
  }
})

export const GptInBox = styled(Box)(props => {
  return {
    height: '100%',
    padding: '4px',
    borderRadius: '8px',
    backgroundColor: '#fff',
    boxShadow: `0px 2px 4px ${theme.palette.grey.w200}`,
  }
})

// ------------------------ ChatList ------------------------ 
export const ChatEmptyBox = styled(Box)(props => {
  return {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }
})

export const ChatListBox = styled(Box)(props => ({
  overflow: 'auto',
}))

export const ChatItemBox = styled(Box)(props => ({
  display: 'flex',
  width: '100%',
  marginBottom: '24px',
}))

// ------------------------ ChatItem ------------------------ 
export const MugShot = styled(Box)(({ role }) => {
  const backgroundColor = role === 'user' ? theme.palette.primary.w400 : theme.palette.secondary.w400;

  return {
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '34px',
    height: '34px',
    padding: '20px',
    overflow: 'hidden',
    borderRadius: '50%',
    backgroundColor: backgroundColor,
  }
})

export const MassageBox = styled(Box)(({ role }) => {
  if (role === 'user') {
    return {
      // position: 'relative',
      alignItems: 'center',
      overflow: 'hidden',
      marginLeft: '10px',
      padding: '12px',
      paddingTop: '16px',
      borderRadius: '0 16px 16px 16px',
      backgroundColor: theme.palette.primary.w50,
    }
  }
  return {
    alignItems: 'center',
    overflow: 'hidden',
    marginLeft: '10px',
    padding: '16px 12px 12px 12px',
    borderRadius: '0 16px 16px 16px',
    backgroundColor: '#F3F3F3',
  }
})

export const ContentStyle = {
  whiteSpace: 'pre-line',
  wordBreak: 'break-all',
  overflowWrap: 'break-word',
  maxWidth: '100%',
  marginBottom: '0.5em',
  lineHeight: 1.5,
  fontSize: 'inherit'
}